import { SvgIconComponent } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

export type ServiceIconSize = "s" | "m" | "l" | "xl";

@Component({
  selector: "service-icon",
  templateUrl: "service-icon.html",
  styleUrl: "service-icon.scss",
  host: {
    "[class]": "getCssClasses()",
    "[class.active]": "active()",
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent],
})
export class ServiceIcon {
  type = input.required<string>();
  active = input<boolean>(true);
  firewallEnabled = input<boolean>(false);
  size = input<ServiceIconSize>("xl");

  protected getCssClasses = computed(() => `service-icon--${this.type()} service-icon--size-${this.size()}`);
}
